import { VideoSliderItem } from 'shared/components'

// import { scenarioFormId } from 'components'
import img from 'assets/images/zaglushka.png'

type queryType = { [key: string]: string }

export const getSliderItems = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  query: queryType,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setQuery: (q: queryType) => void
): VideoSliderItem[] => {
  return [
    {
      title: 'KION',
      descr:
        'Мы создаем оригинальный развлекательный контент, развиваем сервисы для просмотра фильмов и сериалов в каждом доме и на любом устройстве.',
      video: 'https://www.youtube.com/embed/LVBkkUELye4',
      bgImg: img,
      noBtn: true,
    },
    {
      title: 'Создание',
      descr:
        'Разрабатываем идеи для создания оригинального контента. Привлекаем к сотрудничеству авторов сценария и продюсеров.',
      video: 'https://www.youtube.com/embed/RCpPlZujRZo',
      bgImg: img,
      noBtn: true,
      // btnText: 'Отправить заявку',
    },
    {
      title: 'Производство',
      descr:
        'Продюсируем, инвестируем в производство и снимаем сериалы, фильмы и документалистику нового поколения.',
      link: '/production',
      video: 'https://www.youtube.com/embed/g5vmr_5Iz3s',
      bgImg: img,
    },
    {
      title: 'Дистрибуция',
      descr:
        'Привлекаем клиентов используя собственные ресурсы доставки контента, а также через широкую сеть внешних партнерств как в цифровом, так и оффлайн форматах.',
      link: '/distribution',
      video: 'https://www.youtube.com/embed/1qkisoIctbU',
      bgImg: img,
    },
  ]
}
